// Role GUIDs (matching backend SeedEntityIds)
export const Roles = Object.freeze({
  SuperAdmin: '0CE59357-93BA-51F7-9BAF-03A4A5FF10AC',
  Admin: 'FE333FAE-39A0-5B4C-B8B0-889969C37B5E',
  Manager: 'F3659B84-F37C-5730-B529-6787DA80FA28',
  Employee: 'A26DBE37-89F6-5FA9-AE92-0CE22BD8CD0D',
  ChannelPartnerAdmin: '27A15D4B-B246-5A02-8B06-7F9A866F9FDE',
  ChannelPartnerUser: '9CC96E18-5EC1-5C02-AA09-9E8995B36B89',
});

export function isChannelPartnerRole(roleId) {
  // roleId is now a GUID string
  const roleIdUpper = String(roleId || '').toUpperCase();
  return roleIdUpper === Roles.ChannelPartnerAdmin.toUpperCase() || 
         roleIdUpper === Roles.ChannelPartnerUser.toUpperCase();
}

function roleEquals(roleId, expected) {
  return String(roleId || '').toUpperCase() === String(expected).toUpperCase();
}

export function isSuperAdminRole(roleId) {
  return roleEquals(roleId, Roles.SuperAdmin);
}

export function isAdminOrManagerRole(roleId) {
  return roleEquals(roleId, Roles.Admin) || roleEquals(roleId, Roles.Manager);
}

export function isEmployeeRole(roleId) {
  return roleEquals(roleId, Roles.Employee);
}
